import { Alert, AlertDescription, VStack } from '@chakra-ui/react';
import { Rabbit } from 'lucide-react';
import type { FC, ReactNode } from 'react';
import { GradientIcon } from '~/common/components/GradientIcon';

type Props = {
  message: ReactNode;
  status?: 'warning' | 'error';
};

export const ValidationWarningBanner: FC<Props> = ({
  message,
  status = 'warning',
}) => {
  return (
    <Alert
      alignItems="flex-start"
      borderRadius="md"
      gap={2}
      p={3}
      pl={2}
      pr={4}
      status={status}
      variant="subtle"
    >
      <GradientIcon icon={Rabbit} mt={1} />
      <VStack align="stretch" spacing={1}>
        <AlertDescription fontSize="sm">{message}</AlertDescription>
      </VStack>
    </Alert>
  );
};
